<template>
  <div class="flex items-center">
    <ul class="users-liked user-list">
      <li v-for="(user, userIndex) in dispatchedOrders[0].usersLiked" :key="userIndex">
        <vx-tooltip :text="user.name" position="bottom">
          <vs-avatar
            :src="user.img"
            size="30px"
            class="border-2 border-white border-solid -m-1"
          ></vs-avatar>
        </vx-tooltip>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: "CellRenderSelfies",
  data() {
    return {
      dispatchedOrders: [
        {
          orderNo: 879985,
          status: "Moving",
          statusColor: "success",
          operator: "Cinar Knowles",
          operatorImg: require("@/assets/images/portrait/small/avatar-s-2.jpg"),
          usersLiked: [
            {
              name: "Vennie Mostowy",
              img: require("@/assets/images/portrait/small/avatar-s-5.jpg"),
            },
            {
              name: "Elicia Rieske",
              img: require("@/assets/images/portrait/small/avatar-s-7.jpg"),
            },
            {
              name: "Julee Rossignol",
              img: require("@/assets/images/portrait/small/avatar-s-10.jpg"),
            },
            {
              name: "Darcey Nooner",
              img: require("@/assets/images/portrait/small/avatar-s-8.jpg"),
            },
          ],
          location: "Anniston, Alabama",
          distance: "130 km",
          distPercent: 80,
          startDate: "26/07/2018",
          estDelDate: "28/07/2018",
        },
        {
          orderNo: 156897,
          status: "Pending",
          statusColor: "warning",
          operator: "Britany Ryder",
          operatorImg: require("@/assets/images/portrait/small/avatar-s-4.jpg"),
          usersLiked: [
            {
              name: "Trina Lynes",
              img: require("@/assets/images/portrait/small/avatar-s-1.jpg"),
            },
            {
              name: "Lilian Nenez",
              img: require("@/assets/images/portrait/small/avatar-s-2.jpg"),
            },
            {
              name: "Alberto Glotzbach",
              img: require("@/assets/images/portrait/small/avatar-s-3.jpg"),
            },
          ],
          location: "Cordova, Alaska",
          distance: "234 km",
          distPercent: 60,
          startDate: "26/07/2018",
          estDelDate: "28/07/2018",
        },
      ],
    };
  },
  computed: {
    url() {
      return "/engineer/engineer-view/" + this.params.data.userID;

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    },
  },
};
</script>
